import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const outsourcerSlice = createSlice({
    name: 'outsourcer',
    initialState,
    reducers: {
        setOutsourcerPageAction: (state, action) => {
            state.page = action.payload
        },
        getOutsourcerPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addOutsourcerAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateOutsourcerAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteOutsourcerAction: (state, action) => {
            const content = state.page.content.filter(x => x.id !== action.payload)
            state.page.content = content
        },
        uploadOutsourcerExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        }
    },
});

export const { setOutsourcerPageAction, getOutsourcerPageAction, addOutsourcerAction, updateOutsourcerAction, deleteOutsourcerAction, uploadOutsourcerExcelFileAction } = outsourcerSlice.actions;
export default outsourcerSlice;